import TextGenerate from './TextGenerate';
import './text-generate.scss';

export default TextGenerate;